import { render, staticRenderFns } from "./HuichuanPlatform.vue?vue&type=template&id=3d8ca54e&scoped=true"
import script from "./HuichuanPlatform.vue?vue&type=script&lang=js"
export * from "./HuichuanPlatform.vue?vue&type=script&lang=js"
import style0 from "./HuichuanPlatform.vue?vue&type=style&index=0&id=3d8ca54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ca54e",
  null
  
)

export default component.exports